// extracted by mini-css-extract-plugin
module.exports = {"lds-default":"LoadingSpinner_lds-default__2s7Ug","lds-ripple":"LoadingSpinner_lds-ripple__2Uf92"};